module.exports = __webpack_public_path__ + "files/bc88207f15e3ebef713405135d94f372.png";